import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";
import { raSupabaseEnglishMessages } from "ra-supabase-language-english";
import { englishCrmMessages } from "@/components/atomic-crm/providers/commons/englishCrmMessages";

import {
  mensajesCrmEs,
  mensajesNevoraEs,
  mensajesRaEs,
  mensajesRaSupabaseEs,
} from "./es";
import { mensajesNegociosEs } from "./es-negocios";

// Se parte del catálogo inglés completo (ra-core + ra-supabase + Atomic) y se fusiona
// el castellano encima: cualquier clave sin traducir se muestra en inglés en lugar de
// enseñar la clave en pantalla. Un único idioma → los selectores de idioma se ocultan.
const catalogoIngles = mergeTranslations(
  englishMessages,
  raSupabaseEnglishMessages,
  englishCrmMessages,
);

export const catalogoEs = mergeTranslations(
  catalogoIngles,
  mensajesRaEs,
  mensajesRaSupabaseEs,
  mensajesCrmEs,
  mensajesNevoraEs,
  mensajesNegociosEs,
);

export const i18nProvider = polyglotI18nProvider(
  () => catalogoEs,
  "es",
  [{ locale: "es", name: "Español" }],
  { allowMissing: true },
);
